import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-header-placeholder',
  templateUrl: './header-placeholder.component.html',
  styleUrls: ['./header-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class HeaderPlaceholderComponent {
  public logoImg = 'assets/images/sag-logo/sie-logo-petrol-rgb.svg';
}
